export const GROUP_FILTER_MESSAGE =
  "Edit the Label column and add one or more group names, separated by a comma. Then filter the list by selecting a group.  Ex:  [Mine] or [Mine,Family]";
